import { render, staticRenderFns } from "./DocumentVersionEdit.vue?vue&type=template&id=4b13e396&"
import script from "./DocumentVersionEdit.vue?vue&type=script&lang=js&"
export * from "./DocumentVersionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports